module.exports = __webpack_public_path__ + "img/162.d78f9ec2.jpeg";